export default __webpack_public_path__ + "static/media/vehelix_tick.70865fa1.svg";